export const TENANT_LOADED_SUCCESS = "TENANT_LOADED_SUCCESS";
export const TENANTS_LOADED_SUCCESS = "TENANTS_LOADED_SUCCESS";
export const TENANT_SELECTED = "TENANT_SELECTED";
export const TENANTS_LOADED_FAIL = "TENANTS_LOADED_FAIL";
